import type { GenericHttpError } from '@iconik-io/core/src/http/generic_http_transport';

import type { GenericRetryOptions } from '../client/request';

export function shouldRetryErrorResponse(
  error: GenericHttpError,
  retryOptions: GenericRetryOptions,
): boolean {
  const normalizedMethod = error.request.method.toLowerCase();
  const matchesMethod = retryOptions.method?.some(
    (method) => method === normalizedMethod,
  );
  if (!matchesMethod) {
    return false;
  }
  if (!error.response) {
    return false;
  }

  const matchesStatus = retryOptions.status?.includes(error.response.status);
  if (matchesStatus) {
    return true;
  }

  return false;
}
